import get from 'lodash.get';
import 'isomorphic-fetch';

import { hostCheck, generateHashNum } from './utils/navigation';

export class ConfigError extends Error {
    constructor(msg, ...params) {
        const defaultMsg = 'An Error Occurred while trying to load config';
        super(`${defaultMsg}: ${msg}`, ...params);

        this.name = this.constructor.name;
    }
}

const configLoad = async () => {
    const hashNum = generateHashNum();
    try {
        const configPath = process.env.REACT_APP_CONFIG_LOCAL
            ? `/static/config/config.sandbox.json?hash=${hashNum}`
            : `${hostCheck(
                  window.location.host
              )}/personal-investing/tools/fund-research/static/config/config.json?hash=${hashNum}`;

        const resp = await fetch(configPath);
        return resp.json();
    } catch (err) {
        const msg = 'An error occurred while trying to load config';
        // eslint-disable-next-line no-console
        console.error(msg, err);
        throw new ConfigError(err.message);
    }
};

let config = {};

export const initiateConfig = async () => {
    config = await configLoad();
    return config;
};

export const isDevOrLocalEnv = (host) => {
    if (host.split('.')[0] === 'wwwdev' || host.includes('localhost')) {
        return true;
    }
    return false;
};

export const isLowerEnvironment = (host) => {
    const lowerEnvironmentPrefixes = ['wwwdev', 'wwwstage'];
    return (
        lowerEnvironmentPrefixes.includes(host.split('.')[0]) ||
        host.includes('localhost')
    );
};

export const getEnvDomain = (host) =>
    isDevOrLocalEnv(host) ? 'wwwdev.troweprice.com' : host;

const getConfig = (prop, fallback) => get(config, prop, fallback);

export default getConfig;
